import Marquee from "react-fast-marquee";

const ITEMS = [
  "12 O'CLOCK MOTO CO.",
  "STREET // DIRT // CRUISER",
  "RAW MOTO CULTURE",
  "HEAVYWEIGHT COTTON & APPAREL",
  "NEVER SLOW DOWN",
  "FULL THROTTLE FREEDOM",
];

export const EditorialMarquee = () => (
  <div
    className="relative border-y-2 border-[#111111] bg-[#111111] py-4 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <Marquee speed={55} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <span
          key={i}
          className="font-display font-black text-2xl md:text-4xl uppercase tracking-tighter text-[#FF4500] mx-6 flex items-center gap-6"
        >
          {item}
          <span className="text-white/30">///</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
